import styles from './DocumentItem.module.scss';
export interface DocumentItemProps {
	label: string;
	value: React.ReactNode;
	links?: React.ReactNode[];
	id?: string;
	uid?: number;
}

export const DocumentItem: React.FC<DocumentItemProps> = ({ label, value, links, id, uid }) => {
	const uniqueId = `A${uid}`;
	return (
		<div className={styles.DocumentItem}>
			<p className={styles.DocumentItem_label} id={uniqueId}>
				{label}
			</p>
			<div aria-labelledby={uniqueId} className={styles.DocumentItem_content}>
				{value}
				{links && links.length > 0 && <div className={styles.DocumentItem_links}>{links.map((link, index) => <div key={index}>{link}</div>)}</div>}
			</div>
		</div>
	);
};
